var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4008 0C27.2495 0 28.0634 0.374602 28.6635 1.0414C29.2636 1.70819 29.6008 2.61256 29.6008 3.55556V28.4444C29.6008 29.3874 29.2636 30.2918 28.6635 30.9586C28.0634 31.6254 27.2495 32 26.4008 32H4.00078C3.15209 32 2.33816 31.6254 1.73804 30.9586C1.13792 30.2918 0.800781 29.3874 0.800781 28.4444V3.55556C0.800781 2.61256 1.13792 1.70819 1.73804 1.0414C2.33816 0.374602 3.15209 0 4.00078 0H26.4008ZM25.6008 27.5556V18.1333C25.6008 16.5963 25.0512 15.1221 24.073 14.0353C23.0949 12.9484 21.7682 12.3378 20.3848 12.3378C19.0248 12.3378 17.4408 13.2622 16.6728 14.6489V12.6756H12.2088V27.5556H16.6728V18.7911C16.6728 17.4222 17.6648 16.3022 18.8968 16.3022C19.4909 16.3022 20.0606 16.5644 20.4807 17.0312C20.9008 17.498 21.1368 18.131 21.1368 18.7911V27.5556H25.6008ZM7.00878 9.88445C7.72168 9.88445 8.40539 9.56978 8.90948 9.00967C9.41358 8.44956 9.69678 7.68989 9.69678 6.89778C9.69678 5.24444 8.49678 3.89333 7.00878 3.89333C6.29164 3.89333 5.60386 4.20987 5.09676 4.77331C4.58967 5.33676 4.30478 6.10095 4.30478 6.89778C4.30478 8.55111 5.52078 9.88445 7.00878 9.88445ZM9.23278 27.5556V12.6756H4.80078V27.5556H9.23278Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkin);
export default __webpack_public_path__ + "static/media/linkin.23a8df8932b700e5d18b1fd2404e3548.svg";
export { ForwardRef as ReactComponent };